import React, { useState } from "react";

import "./style.css";

//import sendEmail from "../../utils/emailSender";
import { createLead } from "../../service/webhookService";
import GoldenButton from "../GoldenButton";
import { FiCheckCircle } from "react-icons/fi";

import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const PageEmail = ({ content }) => {
  const [toName, setToName] = useState("");
  const [toEmail, setToEmail] = useState("");
  const [hasEmailSended, setHasEmailSended] = useState(false);
  const [phone, setPhone] = useState();

  const handleToNameChange = (e) => {
    setToName(e.target.value);
  };

  const handleToEmailChange = (e) => {
    setToEmail(e.target.value);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhone = (phone) => {
    if (!phone) return false;
    return isValidPhoneNumber(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(toEmail)) {
      alert("Por favor, insira um endereço de e-mail válido.");
      return;
    }
    if (!isValidPhone(phone)) {
      alert("Por favor, insira um número de telefone válido.");
      return;
    }
    try {
      setHasEmailSended(true);
      createLead(toEmail, toName, phone, content);
    } catch (error) {
      console.error("Erro ao enviar o e-mail:", error);
      alert("Erro ao enviar o e-mail. Por favor, tente novamente.");
    }
  };

  return (
    <div className="email-form-container">
      {!hasEmailSended ? (
        <div className="form-container">
          <div className="form-container-title">
            <h5>Você concluiu o teste!</h5>
            <h6>
              Agora é hora de descobrir qual Deusa está mais viva em você hoje — e o que essa
              energia revela sobre o seu momento atual.
            </h6>
            <h6>
              ✨ Preencha seus dados para receber o resultado e dar o primeiro passo nessa jornada
              de reconexão com o seu feminino.
            </h6>
          </div>
          <form onSubmit={handleSubmit} className="form-container-inputs">
            <input
              type="text"
              value={toName}
              onChange={handleToNameChange}
              required
              placeholder="SEU NOME"
              id="name"
            />
            <input
              type="email"
              value={toEmail}
              onChange={handleToEmailChange}
              required
              placeholder="SEU EMAIL"
              id="email"
            />
            <PhoneInput
              international
              defaultCountry="BR"
              value={phone}
              onChange={setPhone}
              placeholder="SEU TELEFONE"
              className="custom-phone-input"
              name="phone"
              id="phone"
            />
            <GoldenButton
              containerStyle={{ marginTop: "0px" }}
              disabled={!toName || !toEmail}
              content="RECEBER RESULTADO"
            />
          </form>
        </div>
      ) : (
        <div className="container-email fixed-heigth">
          <FiCheckCircle className="check-icon" />
          <h4>Teste concluído com sucesso! </h4>
          <h5>Parabéns! Seu resultado está a caminho.</h5>
          <h6>
            {" "}
            Em até 5 minutos, você receberá o e-mail com a Deusa que vibra em você. Caso não veja na
            caixa de entrada, verifique também as pastas de spam ou promoções.
          </h6>
        </div>
      )}
    </div>
  );
};

export default PageEmail;
